export default "__VITE_ASSET__bMyzXbjr__"